import { HorariosComponent } from './pocae/ubicaciones/horarios/horarios.component';
import { DireccionesComponent } from './pocae/ubicaciones/direcciones/direcciones.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { PocaeComponent } from './pocae/pocae.component';
import { ResumenComponent } from './pocae/resumen/resumen.component';
import { TarjetasComponent } from './pocae/tarjetas/tarjetas.component';
import { PerfilComponent } from './pocae/perfil/perfil.component';
import { MovimientosComponent } from './pocae/tarjetas/movimientos/movimientos.component';
import { SolicitudesComponent } from './pocae/tarjetas/solicitudes/solicitudes.component';
import { UbicacionesComponent } from './pocae/ubicaciones/ubicaciones.component';
import { CentrosAtencionComponent } from './pocae/ubicaciones/centros-atencion/centros-atencion.component';
import { PuntosVentaComponent } from './pocae/ubicaciones/puntos-venta/puntos-venta.component';
import { MapsComponent } from './pocae/ubicaciones/maps/maps.component';
import { ZonasPagasComponent } from './pocae/ubicaciones/zonas-pagas/zonas-pagas.component';


const routes: Routes = [
  { path: '', component: LoginComponent },
  {
    path: 'pocae', component: PocaeComponent,
    children: [
      { path: 'resumen', component: ResumenComponent },
      {
        path: 'tarjetas', component: TarjetasComponent,
        children: [
          { path: 'movimientos', component: MovimientosComponent },
          { path: 'solicitudes', component: SolicitudesComponent }
        ]
      },
      {
        path: 'ubicaciones', component: UbicacionesComponent,
        children: [
          { path: 'centrosAtencion', component: CentrosAtencionComponent },
          { path: 'puntoVenta', component: PuntosVentaComponent },
          { path: 'zonasPagas', component: ZonasPagasComponent },
          { path: 'maps', component: MapsComponent },
          { path: 'direcciones', component: DireccionesComponent },
          { path: 'horarios', component: HorariosComponent }
        ]
      },
      { path: 'perfil', component: PerfilComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
